module.exports = __webpack_public_path__ + "static/media/CKTL_Logo_Subheader.82fe97e3.webp";